import * as endpoints from './endpoints';

const OutreachService = { ...endpoints };

export default OutreachService;
export type { OutreachRow } from './endpoints';
